import { useTranslation } from 'react-i18next';
import './NotificationPopup.css';

// ── Bell icon in header ───────────────────────────────────────────────────────
export function NotificationBell({ count, onClick }) {
  return (
    <div className="notif-bell" onClick={onClick} title="Notifiche gruppo">
      <span className="notif-bell-icon">🔔</span>
      {count > 0 && <span className="notif-bell-badge">{count > 9 ? '9+' : count}</span>}
    </div>
  );
}

// ── Popup panel with notification list ───────────────────────────────────────
export function NotificationPanel({ notifications, onRespond, onClose }) {
  const { t } = useTranslation();

  const pending  = notifications.filter(n => n.status === 'pending');
  const resolved = notifications.filter(n => n.status !== 'pending').slice(0, 10);

  const typeIcon = { task: '☑', event: '◫', shop_item: '◈' };

  return (
    <div className="np-overlay" onClick={onClose}>
      <div className="np-panel" onClick={e => e.stopPropagation()}>
        <div className="np-hdr">
          <span>// {t('group_notif.title')}</span>
          <span className="np-close" onClick={onClose}>{t('common.close')}</span>
        </div>

        {notifications.length === 0 && (
          <div className="np-empty">{t('group_notif.empty')}</div>
        )}

        {pending.length > 0 && (
          <>
            <div className="np-section">{t('group_notif.pending')}</div>
            {pending.map(n => (
              <div className="np-item" key={n.id}>
                <span className="np-icon">{typeIcon[n.type] || '◉'}</span>
                <div className="np-body">
                  <div className="np-title">{n.itemTitle}</div>
                  <div className="np-from">{t('group_notif.from')} {n.fromUser}</div>
                </div>
                <div className="np-actions">
                  <button className="np-btn np-accept"  onClick={() => onRespond(n.id, 'accepted')}>{t('group_notif.accept')}</button>
                  <button className="np-btn np-snooze"  onClick={() => onRespond(n.id, 'snoozed')} >{t('group_notif.snooze')}</button>
                  <button className="np-btn np-decline" onClick={() => onRespond(n.id, 'declined')}>{t('group_notif.decline')}</button>
                </div>
              </div>
            ))}
          </>
        )}

        {resolved.length > 0 && (
          <>
            <div className="np-section np-section-dim">{t('group_notif.resolved')}</div>
            {resolved.map(n => (
              <div className="np-item np-resolved" key={n.id}>
                <span className="np-icon" style={{opacity:0.4}}>{typeIcon[n.type] || '◉'}</span>
                <div className="np-body">
                  <div className="np-title" style={{opacity:0.4}}>{n.itemTitle}</div>
                  <div className="np-from">{t('group_notif.from')} {n.fromUser} — {t(`group_notif.status_${n.status}`)}</div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}

// ── Toast message after sending ───────────────────────────────────────────────
export function NotificationToast({ message }) {
  if (!message) return null;
  return (
    <div className="notif-toast">
      <span className="notif-toast-ic">✓</span>
      {message}
    </div>
  );
}

// ── Member picker (for sharing tasks) ────────────────────────────────────────
export function MemberPicker({ users, onSelect, onClose }) {
  const { t } = useTranslation();
  if (!users || users.length === 0) return null;
  return (
    <div className="mp-overlay" onClick={onClose}>
      <div className="mp-box" onClick={e => e.stopPropagation()}>
        <div className="mp-title">// {t('group_notif.share_with')}</div>
        {users.map(u => (
          <div key={u.id} className="mp-item" onClick={() => onSelect(u)}>
            <span className="mp-avatar">◉</span>
            <span className="mp-name">{u.username}</span>
          </div>
        ))}
        <div className="mp-cancel" onClick={onClose}>{t('common.cancel')}</div>
      </div>
    </div>
  );
}
